module.exports = __webpack_public_path__ + "img/up_arrow_icon.6eb9039f.svg";